import { Action } from "redux"

export const RECEIVE_INDICATORS = "INDICATORS_RECEIVE_INDICATORS"
export const REQUEST_INDICATORS = "INDICATORS_REQUEST_INDICATORS"
export const RECEIVE_INDICATOR = "INDICATORS_RECEIVE_INDICATOR"
export const RECEIVE_INDICATOR_ERROR = "INDICATORS_RECEIVE_INDICATOR_ERROR"
export const REQUEST_INDICATOR = "INDICATORS_REQUEST_INDICATOR"

export interface RequestIndicators extends Action {
    indicatorId: number
    indicatorSchemeId: number
}

export const requestIndicators = (
    indicatorId: number,
    indicatorSchemeId: number,
): RequestIndicators => ({
    type: REQUEST_INDICATORS,
    indicatorId,
    indicatorSchemeId,
})

export interface ReceiveIndicators extends Action {
    indicators: Indicators.IndicatorData[]
}

export const receiveIndicators = (
    indicators: Indicators.IndicatorData[],
): ReceiveIndicators => ({ type: RECEIVE_INDICATORS, indicators })

export interface RequestIndicator extends Action {
    indicatorId: number
}

export const requestIndicator = (indicatorId: number): RequestIndicator => ({
    type: REQUEST_INDICATOR,
    indicatorId,
})

export interface ReceiveIndicator extends Action {
    indicator: Indicators.IndicatorData
}

export const receiveIndicator = (
    indicator: Indicators.IndicatorData,
): ReceiveIndicator => ({ type: RECEIVE_INDICATOR, indicator })

export const receiveIndicatorError = (): Action => ({
    type: RECEIVE_INDICATOR_ERROR,
})

export const mapDispatchToProps = {
    receiveIndicators,
    requestIndicators,
    receiveIndicator,
    receiveIndicatorError,
    requestIndicator,
}

export type DispatchProps = typeof mapDispatchToProps
